var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('chart',{attrs:{"options":_vm.chartOptions}})],1),_c('div',{staticStyle:{"padding-bottom":"50px"},domProps:{"innerHTML":_vm._s(_vm.result.other.criterion?.replace(/\n/ig, '<br/>'))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }